export default {
	field: 'partNumber',
	name: 'Manufacturer Number',
	width: '200px',
}
